<div class="bitcoin-app investments-popup"
     [class.is-paypal]="isPaypalIframe()"
     [class.is-active]="activeClass">
  <div class="bitcoin-app__inner investments-popup__inner">
    <button class="investments-popup__close"
            (click)="handleClose()"></button>
    <iframe [src]="safeUrl" allow="clipboard-write *; clipboard-read *"></iframe>

    <div class="bitcoin-app__paypal"
         *ngIf="isPaypalIframe()">
      <div class="paypal-footer">
        <div class="paypal-footer__wrapper">
          <button class="paypal-footer__btn"
                  [ngStyle]="{'visibility': contentLoaded ? 'visible' : 'hidden'}"
                  [disabled]="paypalOpening"
                  (click)="openPaypal()">
            <ng-container *ngIf="paypalOpening">
              {{ 'paypal' | languageTranslate: [{$innerVariable: 'openingBtn'}]  }}
            </ng-container>
            <ng-container *ngIf="!paypalOpening">
              {{ 'paypal' | languageTranslate: [{$innerVariable: 'openBtn'}]  }}
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
